import htmx from 'htmx.org';
window.htmx = htmx; // Makes htmx available globally.